/** Fin d'un compte personnel : ce que partagent les pages et l'écran de connexion. */

/** Phrase à recopier pour supprimer son compte (le serveur exige la même). */
export const DELETE_PHRASE = 'SUPPRIMER';

/** Paramètre de l'écran de connexion qui dit pourquoi la session vient de finir. */
export const LOGIN_NOTICE_PARAM = 'retour';

/** Raisons annoncées par `?retour=` sur l'écran de connexion. */
export const LOGIN_NOTICES = ['compte_supprime', 'entreprise_quittee', 'appareil_retire', 'double_authentification'] as const;
